import {isServer} from 'coreUtils/utils';
import Manager from 'coreClasses/Manager';
import AbstractLogProvider from './providers/AbstractLogProvider';
import LogProvidersFactory from './LogProvidersFactory';
import ManagerRepository from '../ManagerRepository';

import {EErrorType} from '../errorsStream/IErrorMessage';
import {LogSource} from 'commerceAPI/custom-apis/CustomShopperSystem/ICustomShopperSystem';

/**
 * Represents LogMgr
 */
class LogMgr extends Manager {
	/**
	 * Returns Log provider
	 * @param {String|null} providerId Provider Id
	 * @returns {AbstractLogProvider}
	 */
	public getLogProvider(providerId?: string): AbstractLogProvider {
		if (!providerId) {
			const logProviderPreference = isServer ? 'ssrLogProvider' : 'csrLogProvider';

			providerId = this.managerRepository.getConfigurationsMgr().get(`sitePreferences.${logProviderPreference}`);
		}

		if (providerId) {
			const logProviderFactory = new LogProvidersFactory(this.managerRepository);

			return logProviderFactory.create(providerId);
		} else {
			return null;
		}
	}

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository);

		this.managerRepository.getErrorsStreamMgr().subscribe(this);
	}

	/**
	 * Receives Observer messages
	 * @param {string} key - message key
	 * @param {object} data - data
	 */
	update(key: string, data: object) {
		switch (key) {
			case EErrorType.PRODUCT_NO_PRICE:
				this.getLogProvider()?.error(`${key}: ${JSON.stringify(data)}`, LogSource.PRODUCT as any, {});

				break;
			default:
				return;
		}
	}
}

export default LogMgr;
